<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Add a User</h4>
            <form class="form-sample" @submit="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input required type="text" v-model="name"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="User Name">
                    <b-form-input required type="text" v-model="username"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Phone">
                    <b-form-input required type="text" v-model="phone"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Password">
                    <b-form-input required type="text" v-model="password"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Email">
                    <b-form-input required type="email" v-model="email"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Organization">
                    <b-form-input type="text" v-model="organization"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Gender">
                    <select
                      id="type"
                      class="form-control"
                      name="Chooae Type"
                      required
                      placeholder="Choose Type"
                      v-model="gender"
                    >
                      <option value="female">Female</option>
                      <option value="male">Male</option>
                      <option value="others">Others</option>
                      <option value="notprefertosay">Not prefer to Say</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="State">
                    <b-form-input type="text" v-model="State"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 form-group" style="font-size:16px!important">
                  <label for="exampleInputEmail1">Please upload Image</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file"
                    ref="file"
                    v-on:change="handleFileUpload()"
                  />
                </div>
                <div v-if="image" class="col-md-2">
                  <div width="80px" height="80px" class="card" id="preview">
                    <img width="100%" height="100%" :src="image" />
                  </div>
                </div>
              </div>
              <br />
              <label for="exampleInputEmail1" style="font-size:20px!important">Please Add Location</label>

              <div class="input-group-prepend">
                <br />
                <div class="col-md-6">
                  <input
                    name="lat"
                    type="text"
                    v-model="lat"
                    class="form-control"
                    placeholder="Please Enter Latitude"
                    required
                  />
                </div>
                <br />
                <div class="col-md-6">
                  <input
                    name="lon"
                    type="text"
                    v-model="lon"
                    ref="myLngField"
                    placeholder="Please Enter Longitude"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <hr />

              <div id="myMap"></div>
              <br />
              <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import axios from "axios";
export default {
  name: "addaturtle",
  props: {
    caption: {
      type: String,
      default: "Add a Turtle",
    },
  },
  data: () => {
    return {
      username: "",
      name: "",
      password: "",
      phone: "",
      email: "",
      organization: "",
      occupation: "",
      image: null,
      gender: "",
      state: "",
      file: "",
      id: "",
      loading: false,
      id1: "",
      lat: null,
      lon: null,
    };
  },
  // mounted: function () {
  //   this.loadStats()
  // },
  mounted: function () {
    this.getListClick();
    this.getList();
  },
  watch: {
    lat: function () {
      this.getList();
      this.getListClick();
    },
    lon: function () {
      this.getList();
      this.getListClick();
    },
  },
  methods: {
    resetForm() {
      this.username = "";
      this.name = "";
      this.password = "";
      this.phone = "";
      this.email = "";
      this.occupation = "";
      this.organization = "";
      this.gender = "";
      this.state = "";
      this.error = "";
      this.file = null;
      this.image = null;
    },
    getListClick() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset,
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function (event) {
        this.click = true;
        var clickedLocation = event.latLng;

        if (marker == 1) {
          marker = new google.maps.Marker({
            position: clickedLocation,
            map: map,
            draggable: true,
          });
          google.maps.event.addListener(marker, "dragend", function (event) {
            vm.markerLocation(marker);
          });
        } else {
          marker.setPosition(clickedLocation);
        }

        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },
    getList() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset,
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function (event) {
        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },
    markerLocation(marker) {
      var currentLocation = marker.getPosition();
      this.lat = currentLocation.lat(); //latitude
      this.lon = currentLocation.lng(); //longitude
    },
    onSubmit(evt) {
      evt.preventDefault();
      var add = {};
      add["username"] = this.username;
      add["name"] = this.name;
      add["password"] = this.password;
      add["phone"] = this.phone;
      add["email"] = this.email;
      add["occupation"] = this.occupation;
      add["organization"] = this.organization;
      add["gender"] = this.gender;
      add["state"] = this.state;
      add["lat"] = this.lat;
      add["lon"] = this.lon;

      add["x-auth-token"] = localStorage.getItem("token");
      axios({
        method: "post",
        url: "/user/createuser",
        data: add,
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.id = response.data._id;
          this.loading = "false";
          if (response.data.status === true) {
            this.id1 = response.data.data._id;
            let formData = new FormData();
            formData.append("token", localStorage.getItem("token"));
            formData.append("id", this.id1);
            formData.append("image", this.file);
            this.loading = true;

            axios({
              method: "post",
              url: "/user/imageupload",
              data: formData,
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
              .then((response) => {
                this.resetForm();
                alert("User added Successfully");

                this.$router.push({ path: "/userlist" });
                this.loading = false;
              })
              .catch((e) => {
                this.loading = false;
                this.error = e.response.data.msg;
                alert("User added without image");
              });
          }
          if (response.data.status === false) {
            this.loading = false;

            alert(response.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.image = URL.createObjectURL(this.file);
    },
  },
};
</script>
  
  <style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}

#myMap {
  height: 600px !important;
  width: 100%;
}
</style>